let cachedIp = ''

export const getDeviceIp = async (): Promise<string> => {
  if (cachedIp) return cachedIp

  try {
    const res = await fetch('https://api.ipify.org?format=json')
    const data = await res.json()
    cachedIp = data.ip
    return cachedIp
  } catch (error) {
    console.error('Error fetching device IP:', error)
    return '0.0.0.0'
  }
}
